import './PagesController.scss';
import {useStateCurrentPageNumber, useStateNumberOfPages} from '../../search/search-hooks';
import {useDispatch} from 'react-redux';
import {resetTransformAction, setCurrentPageNumberAction} from '../../search/duck/search-actions';
import {HibuButton} from '../hibuButton/hibuButton';
import {HibuTooltip} from '../hibuTooltip/hibuTooltip';
import {Icons} from '../../icons/icons';
import {PdfPageInput} from '../pdf-viewer/PdfPageInput';

type PagesControllerProps = {
    percentage: number;
    showPagesButtons: boolean;
    handleZoomIn: () => void;
    handleZoomOut: () => void;
    handleResetZoomAndPan: () => void;
    handlePageRotation: (rotation: number) => void;
};

export const PagesController = ({
                                       percentage,
                                       handleZoomIn,
                                       handleZoomOut,
                                       handleResetZoomAndPan,
                                       handlePageRotation,
                                       showPagesButtons
                                   }: PagesControllerProps) => {
    const pageNumber = useStateCurrentPageNumber();
    const numberOfPages = useStateNumberOfPages();
    const dispatch = useDispatch();

    function changePage(pageNumber) {
        dispatch(resetTransformAction(true));
        dispatch(setCurrentPageNumberAction(pageNumber));
    }

    function previousPage() {
        changePage(pageNumber - 1);
    }

    function nextPage() {
        changePage(pageNumber + 1);
    }

    const ZoomControls = () => {
        return (
            <>
                <HibuButton onClick={() => handleZoomOut()} icon={Icons.ZOOM_OUT} visible/>
                <HibuTooltip tooltipKey={'search.document.resetZoom'}>
                    <p id={'reset_zoom'} className={'toolbar-setting-text'}
                       onClick={() => {
                           handleResetZoomAndPan();
                       }}>{percentage} %</p>
                </HibuTooltip>
                <HibuButton onClick={() => {
                    handleZoomIn();
                }} icon={Icons.ZOOM_IN} visible/>
            </>
        );
    };

    const RotationControls = () => {
        return (
            <>
                <HibuButton onClick={() => handlePageRotation(-90)} icon={Icons.ROTATE_LEFT}  className={'hibu-button-embedded-borders'} visible/>
                <HibuButton onClick={() => {
                    handlePageRotation(90);
                }} icon={Icons.ROTATE_RIGHT} className={'hibu-button-embedded-borders'} visible/>
            </>
        );
    };

    function getPagesButtons() {
        return <div className={'page-controller'}>
            <PdfPageInput pageNumber={pageNumber}/>
            <HibuButton onClick={previousPage} icon={Icons.CHEVRON_UP} visible disabled={pageNumber <= 1}/>
            <HibuButton onClick={nextPage} icon={Icons.CHEVRON_DOWN} visible
                        disabled={pageNumber >= numberOfPages}/>
        </div>;
    }

    return (
        <div className={'pdf-floating-controller'}>
            { showPagesButtons ? getPagesButtons() : <></>}
            <div id={'zoomController'} className={'page-controller'}>
                <ZoomControls/>
            </div>
            <div id={'pageRotationController'} className={'page-controller'}>
                <RotationControls/>
            </div>
        </div>
    );

};
